<template>
  <main role="main" id="main_lesson">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li>
            <router-link to="/thu-vien">Danh sách bài giảng</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="pre-lesson__main">
      <div class="container-hts">
        <FilterList />
        <div class="pre-lesson__list">
          <div class="row">
            <div v-for="item in lessons" :key="item.lessonPlanId" class="item col-lg-3 col-md-4 col-sm-6">
              <div class="item__wrap">
                <div class="item__head aspect-ratio aspect-ratio--16-9 text-center border-rd-4 bg-transparent">
                  <router-link :to="{ name: 'prepareLessonEdit', params: { classId: item.classId, subjectId: item.subjectId, id: item.lessonPlanId }}" class="display-block">
                    <div class="item__img" :id="item.lessonPlanId">
                      <img :src="`${baseUrl}/${item.imageUrl}`" :alt="item.title">
                    </div>
                  </router-link>
                </div>
                <div class="item__body">
                  <h3 class="primary-color-txt margin-0 font-size-16 primary-color-txt font-sanpro-semibold">
                    <router-link :to="{ name: 'prepareLessonEdit', params: { classId: item.classId, subjectId: item.subjectId, id: item.lessonPlanId }}" class="primary-color-txt">
                      {{ item.title }}
                    </router-link>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import FilterList from './../_components/list/FilterList'
  import lessonService from './../_api/lessonService'
  import { STORE_KEY } from './../_store/constants'
  import { APP_CONFIG } from '@/utils/constants'

  export default {
    name: 'PrepareDocList',
    components: {
      FilterList
    },
    data() {
      return {
        loadMore: true,
        classId: 0,
        subjectId: 0,
        keyword: '',
        pageIndex: 1,
        pageSize: 12,
        lessons: [],
        baseUrl: APP_CONFIG.appUrl,
      }
    },
    computed: {
      ...mapState(STORE_KEY, ['paramSearch'])
    },
    watch: {
      'paramSearch.classId': 'handleFilterLessons',
      'paramSearch.subjectId': 'handleFilterLessons',
      'paramSearch.keyword': 'handleFilterLessons'
    },
    created() {
      this.getLessons();
    },
    mounted(){
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      document.body.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      ...mapActions('common', ['setLoading']),
      ...mapActions(STORE_KEY, ['acSetParamSearch']),

      async handleScroll (e){
        if(window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 5 && this.loadMore){
          await this.acSetParamSearch({...this.paramSearch, pageIndex: this.paramSearch.pageIndex + 1})
          this.getLessons()
        }
      },

      async handleFilterLessons () {
        this.loadMore = true
        this.lessons = []
        await this.acSetParamSearch({...this.paramSearch, pageIndex: 1})
        this.getLessons()
      },

      getLessons () {
        let self = this;
        self.setLoading(true);
        const { pageIndex, pageSize, classId, subjectId, keyword } = this.paramSearch
        lessonService.filter(pageIndex, pageSize, classId, subjectId, keyword, 0).then((response) => {
            if(this.pageIndex === 1){
              this.lessons = response.data.data.listModels;
            }
            else{
              this.lessons = this.lessons.concat(response.data.data.listModels);
            }
        
            if(this.lessons.length >= response.data.data.total){
              this.loadMore = false;
            }

        })
        .catch(e => {console.error(e)})
        .finally(() => { self.setLoading(false)});
      },
     
    }
  }
</script>

<style lang="scss" scoped>
  .pre-lesson {

    &__list {
      padding: 15px 0;

      .item {
        margin-bottom: 30px;

        &__body {
          padding: 10px 0;
        }

        &:hover {
          .item {
            &__head {
              opacity: 0.8;
            }
          }
        }
      }
    }
  }
</style>
